import React from 'react';
import { Inscription, RoundDoneIcon, WarningCard, WarningIcon } from '@common-fe/common-fe';

interface MatchingMessageCard {
  title: string;
}

export const WarningMessage: React.FC<MatchingMessageCard> = ({ title }) => (
  <WarningCard
    testId="warning_matching"
    icon={<WarningIcon color="warning" size="spacing24" />}
    title={<Inscription color="textBody">{title}</Inscription>}
    backgroundColor="warningContainer"
    borderColor="warningBorder"
    topBorderColor="transparent"
    border={false}
    containerProps={{
      pad: { vertical: 'spacing16', horizontal: 'spacing24' },
      round: 'fieldRound',
    }}
  />
);

export const SuccessMessage: React.FC<MatchingMessageCard> = ({ title }) => (
  <WarningCard
    testId="success_matching"
    icon={<RoundDoneIcon color="success" size="spacing24"  />}
    title={<Inscription color="textBody" weight={700}>{title}</Inscription>}
    backgroundColor="successContainer"
    borderColor="successBorder"
    topBorderColor="transparent"
    border={false}
    containerProps={{
      pad: { vertical: 'spacing16', horizontal: 'spacing24' }
    }}
  />
);
